<template>
  <div class="textarea" :class="[$attrs.class, { 'textarea--error': error, 'textarea--disabled': disabled }]">
    <Label class="textarea__label" :class="{ 'textarea__label--error': error }" :for="id" :required="required"
      ><span class="textarea__label-text">{{ label }}</span
      ><span class="textarea__label-required" v-if="required" aria-hidden="true">*</span></Label
    >
    <textarea
      class="textarea__field"
      :class="[textareaClass, { 'textarea__field--error': error, 'textarea__field--disabled': disabled }]"
      :id="id"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      :tabindex="tabindex"
      :error="error"
      :disabled="disabled"
      :aria-invalid="error ? 'true' : 'false'"
      :aria-describedby="error ? `${id}-error` : undefined"
      :aria-label="label"
      :aria-required="required"
      :rows="rows"
      :value="modelValue"
      @input="handleInput"
    />
    <p class="textarea__error" :id="`${id}-error`" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts" setup>
  import { Label } from 'reka-ui';

  defineProps<{
    label: string;
    id: string;
    name: string;
    placeholder?: string;
    required?: boolean;
    tabindex?: number;
    error?: string;
    disabled?: boolean;
    textareaClass?: string;
    rows?: number;
    modelValue?: string;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
  }>();

  const handleInput = (e: Event) => {
    emit('update:modelValue', (e.target as HTMLTextAreaElement).value);
  };
</script>

<style lang="scss" scoped>
  .textarea {
    @apply w-full flex flex-col gap-2;

    &__field {
      &--error {
        @apply text-[#CF2402] border-[#CF2402];
      }
    }

    &__error {
      @apply text-small-normal;
      color: #cf2402;
    }
  }
</style>
